import { render } from "./base-locale-changer.vue?vue&type=template&id=3130b742&ts=true"
import script from "./base-locale-changer.vue?vue&type=script&lang=ts"
export * from "./base-locale-changer.vue?vue&type=script&lang=ts"

import "./base-locale-changer.vue?vue&type=style&index=0&id=3130b742&lang=scss"

import exportComponent from "/srv/loq/temp/Admin-Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__